// extracted by mini-css-extract-plugin
export var admonition = "styles-module--admonition--3863b";
export var content = "styles-module--content--0d283";
export var info = "styles-module--info--de9ea";
export var noIcon = "styles-module--noIcon--e99a6";
export var tip = "styles-module--tip--b314d";
export var title = "styles-module--title--19827";
export var warn = "styles-module--warn--91065";